/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useComposerMode } from "cms/components/hooks/use-composer-mode";
import { useFieldZone } from "cms/fields/hooks/use-field-zone";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import Config from "data/config";
import { Fragment } from "react";
// import { Logger } from "cms/utils/log/logger";


const FieldEditorButtonsDebug = () => {
    
    const { editMode } = useComposerMode();
    const { field } = useCurrentDynamicField();
    const { FieldZoneState } = useFieldZone();
    const { canUseDefaults = true } = FieldZoneState || {};
    const { name, settings, applyUnifiedSettings, disabled } = field || {};
    const schema = useSelectFieldSchema(name);
    
    const { settings: schemaSettings } = schema || {};
    const {
        noOverride = false,
        hidden = false,
        defaultStyle,
        defaultValue,
        defaultFormat,
    } = schemaSettings || {};
    const noDefaultAvailable = !!defaultValue;

    // Model settings can be changed, unless the schema tells you not to (with noOverride)
    const { style, format, options, hide } = settings || {};
  
    return (
        <Fragment>
  
            {editMode && Config.Debug.enableFieldDebug ? (
                <>
                    <ul style={{ display: "flex", flexDirection: "column" }}>
                        {/*<li style={{ margin: '0', padding: '0', fontSize: '10px'}}>editMode {editMode + ''}</li>*/}
                        
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>canUseDefaults</b>
                            {canUseDefaults ? (
                                <span style={{ color: "green" }}> true </span>
                            ) : (
                                <span style={{ color: "red" }}> false </span>
                            )}
                        </li>
                        
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>noOverride</b>
                            {noOverride ? (
                                <span style={{ color: "green" }}> true </span>
                            ) : (
                                <span style={{ color: "red" }}> false </span>
                            )}
                        </li>
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>disabled</b>
                            {disabled ? (
                                <span style={{ color: "green" }}> true </span>
                            ) : (
                                <span style={{ color: "red" }}> false </span>
                            )}
                        </li>
                        
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>applyUnifiedSettings</b>
                            {applyUnifiedSettings ? (
                                <span style={{ color: "green" }}> true </span>
                            ) : (
                                <span style={{ color: "red" }}> false </span>
                            )}
                        </li>
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>{JSON.stringify(settings)}</li>
                        {/*<li style={{margin: '0', padding: '0', fontSize: '10px', maxWidth: '500px', */}
                        {/*    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',}}>*/}
                        {/*    <b>VALUE:</b> {JSON.stringify(value)}*/}
                        {/*</li>*/}
                        <li style={{ margin: "0", padding: "0", fontSize: "10px", maxWidth: "500px",
                            overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                        >
                            <b>DEFAULT_VALUE:</b> {defaultValue}
                        </li>
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>STYLE:</b> {JSON.stringify(style)}, <b>DEFAULT_STYLE:</b> {defaultStyle}
                        </li>
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>FORMAT:</b> {JSON.stringify(format)}, <b>DEFAULT_FORMAT:</b>{" "}
                            {noDefaultAvailable ? "NONE" : defaultFormat}
                        </li>
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>HIDE:</b> {hide + ""}, <b>HIDDEN:</b> {hidden + ""}
                        </li>
                        <li style={{ margin: "0", padding: "0", fontSize: "10px" }}>
                            <b>OPTIONS:</b> {JSON.stringify(options)}
                        </li>
                    </ul>
                    <div style={{
                        width: "720px",
                        border: "1px solid #DFDFDF", backgroundColor: "#f9f9f9", display: "flex",
                        flexDirection: "column", justifyContent: "center", alignItems: "flex-start", fontSize: "11px",
                        color: "#939393", paddingLeft: "20px",
                    }}
                    >
                        <details>
                            <summary>Field JSON:</summary>
                            <div style={{
                                width: "100%", maxWidth: "700px", fontSize: "11px", overflow: "auto",
                                display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start",
                            }}
                            >
                                <pre>{JSON.stringify(field, null,2)}</pre>
                            </div>
                        </details>
                    </div>
                </>
            ) : null}
        </Fragment>
    );
};

export { FieldEditorButtonsDebug };
